import { useAuth } from "../contexts/AuthContext";

export const RoleGuard = ({ permission, children, fallback = null }) => {
    const { can } = useAuth();
    return can(permission) ? children : fallback;
};

export default RoleGuard;
